export const BROWSE_BY_INDUSTRY_REQUEST = 'BROWSE_BY_INDUSTRY_REQUEST';
export const BROWSE_BY_INDUSTRY_RECEIVE = 'BROWSE_BY_INDUSTRY_RECEIVE';
